import { apiRequest } from './api';

/** The KPI dashboard API in the collectibles backend (LootMachine engine). */
export const KPI_API = '/loot_machine/api/kpi/v1';

export type KpiKey =
  | 'sales_volume'
  | 'sales_count'
  | 'buyback_volume'
  | 'buyback_count'
  | 'redemption_vs_buyback'
  | 'redemption_fmv'
  | 'cards_redeemed'
  | 'shipping_handling'
  | 'refunds'
  | 'refunds_count'
  | 'ggr'
  | 'studio_commission';

export type FigureField =
  | 'sales_volume_cents'
  | 'sales_count'
  | 'buyback_volume_cents'
  | 'buyback_count'
  | 'redemption_share'
  | 'buyback_share'
  | 'redemption_fmv_cents'
  | 'cards_redeemed'
  | 'shipping_handling_cents'
  | 'refunds_cents'
  | 'refunds_count'
  | 'ggr_cents'
  | 'studio_commission_cents';

/** Only the figures of the viewer's own KPIs arrive; a share is null when no
 *  round closed, which is "no data", not "none". */
export type Figures = Partial<Record<FigureField, number | null>>;

export interface KpiOperator {
  id: number;
  name: string;
}

export interface KpiProfile {
  email: string;
  must_change_password: boolean;
  publish_hour_utc: number;
  /** ISO day: the last day published to this viewer. */
  published_through: string;
  kpis: KpiKey[];
  operators: KpiOperator[];
}

export interface KpiSummary {
  from: string;
  to: string;
  published_through: string;
  currency: string;
  timezone: string;
  kpis: KpiKey[];
  totals: Figures;
  operators: (KpiOperator & { figures: Figures })[];
  series: { day: string; figures: Figures }[];
}

export interface SummaryQuery {
  from: string;
  to: string;
  /** Empty = every operator the viewer was given. */
  operatorIds: number[];
}

export function fetchProfile(signal?: AbortSignal): Promise<KpiProfile> {
  return apiRequest<KpiProfile>(`${KPI_API}/me`, signal ? { signal } : {});
}

export function fetchSummary(query: SummaryQuery, signal?: AbortSignal): Promise<KpiSummary> {
  const params = new URLSearchParams({ from: query.from, to: query.to });
  query.operatorIds.forEach((id) => params.append('operator_ids[]', String(id)));

  return apiRequest<KpiSummary>(`${KPI_API}/summary?${params.toString()}`, signal ? { signal } : {});
}
